module.exports = __webpack_public_path__ + "static/media/Marianna Seger.e53225cd.png";